import PropTypes from 'prop-types';
import { createContext, useState, useEffect } from 'react';
// hooks
import useResponsive from '../hooks/useResponsive';

// ----------------------------------------------------------------------

const initialState = {
  collapseClickSetting: false,
  collapseHoverSetting: false,
  onToggleCollapseSetting: () => {},
  onHoverEnterSetting: () => {},
  onHoverLeaveSetting: () => {}
};

const CollapseSettingDrawerContext = createContext(initialState);

// ----------------------------------------------------------------------

CollapseSettingDrawerProvider.propTypes = {
  children: PropTypes.node
};

function CollapseSettingDrawerProvider({ children }) {
  const isDesktop = useResponsive('up', 'lg');

  const [collapse, setCollapse] = useState({
    click: false,
    hover: false
  });

  useEffect(() => {
    if (!isDesktop) {
      setCollapse({
        click: false,
        hover: false
      });
    }
  }, [isDesktop]);

  const handleToggleCollapse = () => {
    setCollapse({ ...collapse, click: !collapse.click });
  };

  const handleHoverEnter = () => {
    if (collapse.click) {
      setCollapse({ ...collapse, hover: true });
    }
  };

  const handleHoverLeave = () => {
    setCollapse({ ...collapse, hover: false });
  };

  return (
    <CollapseSettingDrawerContext.Provider
      value={{
        isCollapseSetting: collapse.click && !collapse.hover,
        collapseClickSetting: collapse.click,
        collapseHoverSetting: collapse.hover,
        onToggleCollapseSetting: handleToggleCollapse,
        onHoverEnterSetting: handleHoverEnter,
        onHoverLeaveSetting: handleHoverLeave
      }}
    >
      {children}
    </CollapseSettingDrawerContext.Provider>
  );
}

export { CollapseSettingDrawerProvider, CollapseSettingDrawerContext };
